module.exports = __webpack_public_path__ + "img/clock.e4bb409d.svg";